var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0.75C3.11719 0.75 0 3.89453 0 7.75C0 11.6328 3.11719 14.75 7 14.75C10.8555 14.75 14 11.6328 14 7.75C14 3.89453 10.8555 0.75 7 0.75ZM7 13.4375C3.85547 13.4375 1.3125 10.8945 1.3125 7.75C1.3125 4.63281 3.85547 2.0625 7 2.0625C10.1172 2.0625 12.6875 4.63281 12.6875 7.75C12.6875 10.8945 10.1172 13.4375 7 13.4375ZM8.09375 9.9375H7.65625V7.53125C7.65625 7.17578 7.35547 6.875 7 6.875H6.125C5.74219 6.875 5.46875 7.17578 5.46875 7.53125C5.46875 7.91406 5.74219 8.1875 6.125 8.1875H6.34375V9.9375H5.90625C5.52344 9.9375 5.25 10.2383 5.25 10.5938C5.25 10.9766 5.52344 11.25 5.90625 11.25H8.09375C8.44922 11.25 8.75 10.9766 8.75 10.5938C8.75 10.2383 8.44922 9.9375 8.09375 9.9375ZM7 6C7.46484 6 7.875 5.61719 7.875 5.125C7.875 4.66016 7.46484 4.25 7 4.25C6.50781 4.25 6.125 4.66016 6.125 5.125C6.125 5.61719 6.50781 6 7 6Z",
    fill: "#5BCDDA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo);
export default __webpack_public_path__ + "static/media/icon-info.a15040d5c11fb3bc9441b30f81fdd3c9.svg";
export { ForwardRef as ReactComponent };